export default class GongqiDataType
{
	remoteClass = "gongqi.erp.gotmodel.datatype.GongqiDataType";
	
	static TypeString = "String";
	static TypeLong = "Long";
	static TypeDecimal = "Decimal";
	static TypeDate = "Date";
	static TypeTime = "Time";
	static TypeBoolean = "Boolean";
	static TypeEnum = "Enum";
	static TypeComponent = "Component";
	
	static TTypeString = "TypeString";
	static TTypeLong = "TypeLong";
	static TTypeDecimal = "TypeDecimal";
	
	static TypeStringLabel = "String";
	static TypeLongLabel = "Long";
	static TypeDecimalLabel = "Decimal";
	static TypeDateLabel = "Date";
	static TypeTimeLabel = "Time";
	static TypeBooleanLabel = "Boolean";
	static TypeEnumLabel = "Enum";
	static TypeComponentLabel = "Component";
}



// WEBPACK FOOTER //
// ./src/remote/GongqiDataType.js